import React, { useContext, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import BtnOffcanvas from '../../../Components/btn/btnOffcanvas';
import HeaderBase from './headerBase';
import DropDownDark from '../../../Components/dropdown/dropdownDark';
import LoginModal from '../../../Components/modal/loginModal';
import { getUserFromLocalStorage } from '../../../utils/localStorage';
import { AppConfigContext } from '../../../Config/App';
import { LanguageContext } from '../../../Data/Context/languageContext';
import dropDownList from '../../../Components/dropdown/languages.json';
import Ads from '../../../Components/ads';
import { useState } from 'react';

const HomepageHeader = (props) => {
    const user_session = getUserFromLocalStorage();
    const { navigate_to } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);
    const { pokemon_name } = useParams();
    const [title, setTitle] = useState();

    useEffect(() => {
        if (pokemon_name)
            setTitle(t("title_best_builds"));
        else
            setTitle(t("title_top_builds"));

    }, [t, pokemon_name]);

    return (
        <>
            <HeaderBase>

                <div className="col d-flex justify-content-center justify-content-sm-end order-1 order-sm-2 pe-0">
                    <BtnOffcanvas classes="btn-primary me-2 d-lg-none header-btn" offcanvas="offcanvas-search-1" text="Search Builds" icon="fa-solid fa-magnifying-glass"></BtnOffcanvas>

                    <div className='d-none d-lg-block me-3'>
                        <DropDownDark classes="dropdown dropstart" changeLanguage={true} buttonText="English" dropDownList={dropDownList} />
                    </div>
                    {user_session.user_id
                        ?
                        <Link className='btn btn-success header-btn' to={navigate_to('new-build')}>
                            {t("create_build")} <i className='fa-solid fa-plus'></i>
                        </Link>
                        :
                        <button className='btn btn-success header-btn' type="button" data-bs-toggle="modal" data-bs-target="#login-modal">
                            {t("create_build")} <i className='fa-solid fa-plus'></i>
                        </button>
                    }
                </div>

                <div className='col-12 p-0 order-2 my-3'>
                    <Ads classes="container text-center" slot="2603494603" />
                </div>

                <div className="col-12 col-sm-4 col-xl-4 col-xxl-3 text-center order-3 order-sm-1">
                    <h1 className="mb-0 site-title box">{title}</h1>
                </div>
            </HeaderBase>
            <LoginModal />
        </>
    );
}
export default HomepageHeader;